import React, { useState } from "react";
import { array, string, number } from "prop-types";

import CollectionNameTabs from "../../../molecules/CollectionNameTabs";
import NumberedStoryHeadline from "../../../molecules/NumberedStoryHeadline";
import DfpContainer from "../../../ads/dfp-container";
import { DfpComponent } from "../../../ads/dfp-component";

import { getSlotId } from "../../../utils/utils";
import { useDevice } from "../../../utils/react-utils";

import "./organism1.m.css";

const Organism1 = ({
  subCollections,
  mostCommentedStoriesList,
  mostCommentedTitle,
  mostCommentedPosition,
  storiesToLoadInRemainingCollections,
  adSlot,
  collectionSlug,
  layoutName,
}) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const { tab } = useDevice();

  const onTabClick = (selectedTabIndex) => setSelectedIndex(selectedTabIndex);
  const subCollectionNames = subCollections.map((item) => item.name);
  mostCommentedPosition > 1 && subCollectionNames.splice(mostCommentedPosition - 2, 1, mostCommentedTitle);

  const SubCollectionStories = subCollections.map((subCollection) =>
    subCollection.items.filter((item) => item.type === "story")
  );
  mostCommentedPosition > 1 &&
    SubCollectionStories.splice(mostCommentedPosition - 2, 1, mostCommentedStoriesList || []);

  return (
    <div styleName="base">
      <CollectionNameTabs
        collectionList={subCollectionNames.slice(0, 3)}
        selectedIndex={selectedIndex}
        onTabClick={onTabClick}
      />
      <NumberedStoryHeadline
        storyList={SubCollectionStories[selectedIndex].slice(0, storiesToLoadInRemainingCollections)}
        className="numbered-story-headline"
      />

      {tab && (
        <DfpContainer>
          <div styleName="ad-slot-300x250" className="adsBox">
            <DfpComponent
              type={adSlot}
              collectionSlug={collectionSlug}
              slotId={getSlotId(adSlot, collectionSlug, "four-collection-12-stories")}
              layoutName={layoutName}
            />
          </div>
        </DfpContainer>
      )}
    </div>
  );
};

Organism1.propTypes = {
  subCollections: array.isRequired,
  mostCommentedStoriesList: array,
  mostCommentedTitle: string,
  mostCommentedPosition: number,
  storiesToLoadInRemainingCollections: number,
  adSlot: string,
  collectionSlug: string,
  layoutName: string,
};

export default Organism1;
